import globals from "../../constants/globals"

export const theme = {
  colors: {
    primaryColor: `${globals.PRIMARY_COLOR}`,
    secondaryColor: `${globals.SECONDARY_COLOR}`,
  },
}
